import { AlarmList } from "./AlarmList";
export default AlarmList;
